import React from 'react'

export function LinkInNewPage({text, href, size = '12px', color = '#73233c' } = {}) {
  return (
    <a target="_blank" href={href} style={{ color }}>
      {text}
      <svg style={{ width: size, height: size, marginLeft: '2px' }}>
        <use href="./img/open_link_in_new_page.svg#open_link_in_new_page" />
      </svg>
    </a>
  )
}



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/item/LinkInNewPage.jsx